import React, { PureComponent } from 'react'
import './index.scss'

class Footer extends PureComponent {
  render() {
    return (
      <div className="foot or">
        <div className="con or">
          <ul>
            <li>
              <a
                href="http://service.lanxiongsports.com/about/"
                target="_blank"
                rel="noopener noreferrer"
              >
                关于懒熊
              </a>
              <em />
              <a
                href="http://service.lanxiongsports.com/about/#/jobs"
                target="_blank"
                rel="noopener noreferrer"
              >
                加入我们
              </a>
              <em />
              <a
                href="http://service.lanxiongsports.com/about/#/contact"
                target="_blank"
                rel="noopener noreferrer"
              >
                联系我们
              </a>
            </li>
            <li>反馈建议：yuekunpeng@lanxiongsports.com</li>
            <li>© 懒熊体育 版权所有 复制必究 京ICP备15019109号-2</li>
          </ul>
          <ul>
            <li>
              <h1>
                <i />
                友情链接
              </h1>
            </li>
            <li>
              <a
                href="http://weibo.com/lanxiongsports/home?topnav=1&amp;wvr=6"
                target="_blank"
                rel="noopener noreferrer"
              >
                新浪微博
              </a>

              <em />
              <a
                href="http://toutiao.com/m3405401991/"
                target="_blank"
                rel="noopener noreferrer"
              >
                今日头条
              </a>

              <em />
              <a
                href="http://www.iheima.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                i黑马网
              </a>

              <em />
              <a
                href="http://www.huxiu.com  "
                target="_blank"
                rel="noopener noreferrer"
              >
                虎嗅网
              </a>

              <em />
              <a
                href="http://kuaibao.qq.com/s/MEDIANEWSLIST?chlid=19951"
                target="_blank"
                rel="noopener noreferrer"
              >
                天天快报
              </a>

              <em />
              <a
                href="http://www.niceui.cn"
                target="_blank"
                rel="noopener noreferrer"
              >
                奈思设计
              </a>

              <em />
              <a
                href="http://36kr.com/user/1747537840"
                target="_blank"
                rel="noopener noreferrer"
              >
                36Kr
              </a>
              <em />
              <a
                href="http://c.3g.163.com/nc/qa/newsapp/question_share.html?tid=T1439790618143"
                target="_blank"
                rel="noopener noreferrer"
              >
                网易
              </a>

              <em />
              <a
                href="http://mp.sohu.com/profile?xpt=bGFueGlvbmcyMDE0QHNpbmEuY29t"
                target="_blank"
                rel="noopener noreferrer"
              >
                搜狐
              </a>

              <em />
              <a
                href="http://k.sina.cn/media_5136739626.html?vt=4"
                target="_blank"
                rel="noopener noreferrer"
              >
                新浪看点
              </a>
            </li>
          </ul>
          <dl>
            <dd>
              <img
                src="http://imgcdn.lanxiongsports.com/metadatas/54/14084/1453797438.jpg"
                alt=""
              />
            </dd>
            <dt style={{ whiteSpace: 'nowrap' }}>扫码关注懒熊官方微信</dt>
          </dl>
        </div>
      </div>
    )
  }
}

export default Footer
